const assignmentTypes = [
  'Assessment',
]

export default assignmentTypes


// WEBPACK FOOTER //
// ./src/config/assignmentTypes.js